


// export const API_URL = 'http://localhost:8000/v1';
// export const API_URL = 'https://appstaging-api.diamondsdirect.com/v1';
export const API_URL = process.env.REACT_APP_API_URL;

// export const CUSTOMER_API_URL = 'http://localhost:8000/v1';
// export const CUSTOMER_API_URL = 'https://ddstuserapi1.diamondsdirect.com';
export const CUSTOMER_API_URL = process.env.REACT_APP_CUSTOMER_API_URL;
export const CUSTOMER_CREATE_URL = process.env.REACT_APP_CUSTOMER_CREATE_URL;

// export const PRODUCT_API_URL = 'http://localhost:8000/v1';
// export const PRODUCT_API_URL = 'https://ddstprodapi1.diamondsdirect.com';
export const PRODUCT_API_URL = process.env.REACT_APP_PRODUCT_API_URL;

// export const DD_ONLINE_API_URL = 'https://stdapi.diamondsdirect.com';
export const DD_ONLINE_API_URL = process.env.REACT_APP_DD_ONLINE_API_URL;

export const RAPNET_API_URL = 'https://technet.rapaport.com';
export const RAPNET_USER = 'nvxl7rt7kjvtthqi8hcshdotef96kb';
export const RAPNET_PASS = 'MXmqDSat';

// export const FRONTEND_URL = 'https://appstaging.diamondsdirect.com';
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;

export const HEADERS = {
	'Accept': 'application/json',
	'Content-Type': 'application/json',
};
export const ONLINE_HEADERS = {
	'Accept': 'application/json',
	'Content-Type': 'application/json',
	'accesstoken': process.env.REACT_APP_DD_ONLINE_API_KEY,
}
export const RAPNET_HEADERS = {
	'Content-Type': 'application/x-www-form-urlencoded'
};
export const FILE_HEADERS = {
	'Accept': 'application/json'
};

// export const IS_STAGING = true;
export const IS_STAGING = process.env.REACT_APP_PLATFORM !== 'PROD';